/**
 * Текстовые подсказки для undo/redo в контекстном меню.
 * Должны совпадать с обработчиком клавиш в ArchiX6 (Ctrl|Meta + Z / Shift+Z / Y).
 */
export function getHistoryUndoRedoShortcutHints(): {undo: string; redo: string} {
	if (typeof navigator === 'undefined') {
		return {undo: 'Ctrl+Z', redo: 'Ctrl+Y'};
	}
	if (isAppleLikePlatform()) {
		return {undo: '⌘Z', redo: '⇧⌘Z'};
	}
	return {undo: 'Ctrl+Z', redo: 'Ctrl+Y'};
}

/** Подсказки для копирования/вставки узлов на доске X6 (см. boardCopyPastePlugin). */
export function getBoardCopyPasteShortcutHints(): {copy: string; paste: string} {
	if (typeof navigator === 'undefined') {
		return {copy: 'Ctrl+C', paste: 'Ctrl+V'};
	}
	if (isAppleLikePlatform()) {
		return {copy: '⌘C', paste: '⌘V'};
	}
	return {copy: 'Ctrl+C', paste: 'Ctrl+V'};
}

function isAppleLikePlatform(): boolean {
	const p = navigator.platform ?? '';
	if (/Mac|iPhone|iPad|iPod/i.test(p)) return true;
	const ua = navigator.userAgent ?? '';
	return /Mac OS X|iPhone|iPad|iPod/i.test(ua);
}
